import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from 'src/app/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../../../services/notification.service';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})
export class SetNewPasswordComponent implements OnInit {

  form: FormGroup;
  key: string;
  submitted = false;
  isLoading = false;
  linkAlreadyUsed = false;

  constructor(private builder: FormBuilder,
    private usersService: UserService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private location: Location,
    private router: Router,
    public translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit() {
    this.form = this.builder.group({'password': ['', [Validators.required, Validators.minLength(6)]]});
    this.route.params.subscribe(params => {
      this.key = params['key'];
      this.checkLink();
    });
  }

  setPassword(post) {
    this.submitted = true;
    if (this.form.invalid || this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.usersService.changePassword({password: post.password, activationKey: this.key}).subscribe(() => {
      this.isLoading = false;
      this.notificationService.success('wachtwoord gewijzigd');
      this.router.navigate(['/login']);
    });
  }

  checkLink() {
    this.usersService.checkLink(this.key).subscribe(
      () => this.linkAlreadyUsed = false,
      () => this.linkAlreadyUsed = true
    );
  }

  get f() { return this.form.controls; }

}
